import { commonSlice } from "./reducers";
export const { toogleBackdrop, setVideoUploadData, setIsVideoUploading } =
  commonSlice.actions;
export default commonSlice.actions;
